const SvgHardware4 = (props) => (
  <>
    <path d="M80 16v64H16V16h64M96 0H0v96h96V0Z" fill={props.p40} />
  </>
);

export default SvgHardware4;
